import { Checkbox, createTheme, type MantineTheme } from '@mantine/core';
import type { PartialDeep } from 'type-fest';

export const ThemedMantineCheckbox: PartialDeep<MantineTheme> = createTheme({
  components: {
    Checkbox: Checkbox.extend({
      defaultProps: {
        color: 'purple.4',
      },
    }),
  },
});
